import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import context from '../core/context'

function FilterButton({ term }) {
  const { isSelected, toggleFilter } = useContext(context)

  function handleFilterClick() {
    toggleFilter(Number(term.term_id), term.taxonomy)
  }

  return (
    <button
      className={`developer-search__filter${isSelected(term.term_id, term.taxonomy) ? ' developer-search__filter--selected' : ''}`}
      type="button"
      onClick={handleFilterClick}
    >
      <img
        className="icon"
        src={term.icon ? term.icon.url : `${window.sapiens.path}/resourses/images/default-icon.svg`}
        alt={term.name}
      />
      <span className="name">{term.name}</span>
    </button>
  )
}

FilterButton.propTypes = {
  term: PropTypes.object.isRequired,
}

export default FilterButton
